import {clientFIO, clientFirstName, clientLastName, clientMiddleName} from "./SystemEntity";
import {useRoute} from "react-router5";

export function systemEntityValueByKeyword(contract: any, keyword: string, entityId: string | null = null) {
    if (!contract) {
        return null
    }

    if (!contract.system_entities) {
        return null
    }

    let system_entity = contract.system_entities.filter((entity: any) =>
        entity.keyword == keyword || entity.keyword == entityId || entity.id == entityId
    )[0]

    if (system_entity && typeof system_entity.value !== 'undefined' && system_entity.value?.length > 0) {
        return system_entity.value
    } else {
        let fioEntities = [clientFirstName.id, clientMiddleName.id, clientLastName.id]
        if (fioEntities.includes(keyword) || (entityId && fioEntities.includes(entityId))) {
            let fio = contract.system_entities.filter((entity: any) =>
                entity.keyword == clientFIO.keyword
            )[0]?.value
            if (!fio) {
                return null
            }

            // Удаляем множественные пробелы и неразрывные пробелы, затем разделяем по пробелам
            let components = fio.replace(/\s+/g, ' ').trim().split(" ")
            if (components.length == 3) {
                if (keyword == clientFirstName.id || entityId == clientFirstName.id) {
                    return components[1]
                }
                if (keyword == clientLastName.id || entityId == clientLastName.id) {
                    return components[0]
                }
                if (keyword == clientMiddleName.id || entityId == clientMiddleName.id) {
                    return components[2]
                }
                return null
            }

            // if (components.length == 2) {
            //     if (keyword == clientFirstName.id || entityId == clientFirstName.id) {
            //         return components[1]
            //     }
            //     if (keyword == clientLastName.id || entityId == clientLastName.id) {
            //         return components[0]
            //     }
            //     return null
            // }
            //
            // if (components.length == 1) {
            //     if (keyword == clientLastName.id || entityId == clientLastName.id) {
            //         return components[0]
            //     }
            //     return null
            // }

            return null
        } else {
            return null
        }
    }
}

export function canEditSystemEntityById(contract: any, entityId: string, keyword: string | null = null) {
    if (!contract) {
        return true
    }
    if (!contract.system_entities) {
        return true
    }

    const is_first_signer = useRoute().route.params.is_first_signer ?? false

    if (is_first_signer) {
        // Для первого подписанта вообще не смотрим на editable в system_entities.
        // editable в system_entities только для второго подписанта. Возможно, надо добавить editable_for_first_signer,
        // чтобы дать возможность настраивать для первого подписанта
        return true
    }

    let system_entity = contract.system_entities.filter((entity: any) =>
        entity.id == entityId || entity.keyword == keyword || entity.keyword == entityId
    )[0]

    return system_entity?.editable ?? true
}

export function dateFromIsoToPlain(isoDate: string | Date | null | undefined) {
    if (isoDate == null || isoDate === '') {
        return ''
    }

    if (isoDate instanceof Date) {
        if (isNaN(isoDate.getTime())) {
            return ''
        }
        return isoDate.toLocaleDateString('ru-RU')
    }

    const raw = String(isoDate).trim()
    if (!raw) {
        return ''
    }

    // YYYY-MM-DD HH:mm:ss — как в Mongo/ответе API без T (иначе не матчится ISO-регекс и ломается маска ДД.ММ.ГГГГ)
    const sqlDateTimeSpace =
        /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(\.\d{1,3})?$/
    if (sqlDateTimeSpace.test(raw)) {
        const date = new Date(raw.replace(' ', 'T'))
        if (!isNaN(date.getTime())) {
            return date.toLocaleDateString('ru-RU')
        }
    }

    // ISO 8601: YYYY-MM-DD, YYYY-MM-DDTHH:mm:ss, смещение +00:00 и т.д.
    const isoDatePattern =
        /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[+-]\d{2}:\d{2})?)?$/

    if (!isoDatePattern.test(raw)) {
        return raw
    }

    const date = new Date(raw)

    if (isNaN(date.getTime())) {
        return raw
    }

    return date.toLocaleDateString('ru-RU')
}

export function contractSystemEntityIsHidden(contract: any, entityId: string): boolean {
    return contractSystemEntity(contract, entityId)?.hidden ?? true
}

export function contractSystemEntity(contract: any, entityId: string): any | undefined {
    return (contract?.system_entities ?? []).filter((entity: any) => entity.id == entityId || entity.keyword == entityId)[0]
}

export function entityById(entities: any[], entityId: string): any | undefined {
    return entities.filter((entity: any) => entity.id == entityId || entity.keyword == entityId)[0]
}